import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverTeamEntity } from '../../domain/entities/DriverTeamEntity'
import type { DriverTeamAdminDto } from '@/backend/market'
export class DriverTeamModel extends DriverTeamEntity {
  constructor(dataDto: DriverTeamAdminDto) {
    super()
    mapEntityProperties<DriverTeamEntity>(this, dataDto)
  }
}
